
  export default {
    name: 'Theme2DesktopForcePlayerToAddBank',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: 'addBankAccountAttentionDetailForWithdrawal'
      },
      btn: {
        type: String,
        default: 'addAccount'
      }
    },
    computed: {
      modal: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    }
  }
